import gql from "graphql-tag";

export default gql`
  fragment MorningstarPersonFields on MorningstarPerson {
    id
    centralIndexKey
    firstName
    lastName
    fullName
    prefix
    suffix
    age
    gender
    standardTitle
    reportedTitle
    isOfficer
    isDirector
    isIndependentDirector
    isChiefExecutiveOfficer
    status
    biography
    reportDate
    reportSource
  }
`;
